import NewClients from "./new_clients";
import PeopleKnow from "./people_know";

export default function RightWrap() {
    return <div className="lg:max-w-[370px] md:max-w-[510px] mx-auto">
        <div className="xl:space-y-6 space-y-3 md:pb-12" uk-sticky="end: #js-oversized; offset: 50; media:992">
            <PeopleKnow />
            <NewClients />
        </div>
    </div>
}